<template>
  <Queues />
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import Queues from '@/components/QueuesView.vue';

export default defineComponent({
  name: 'HomePage',
  components: {
    Queues,
  },
});
</script>
